import React, { useState, useEffect } from 'react';
import KickImage from 'Reuseables/KickImage';
import { Button, Modal, Input, InputGroup, Form, FormGroup } from 'reactstrap';
import { Link, BrowserRouter } from 'react-router-dom';
import eyeOpen from '../../images/eye-open.png';
import eyeClose from '../../images/eye-close.png';
import { isValidPassword } from '../../helpers/regex';
// import Loading from '../../components/Loading';

type Props = {
  isOpen: boolean;
  isSubmit: boolean;
  hasPassword: boolean;
  onToggle: () => any;
  onClick: (...args: any) => any;
  titleModal: string;
  password: string;
  errorMessage: string;
  toggleModalSellerVerification: () => any;
};

const ModalPasswordV3 = ({
  onToggle,
  isSubmit,
  isOpen,
  titleModal,
  hasPassword,
  errorMessage,
  onClick,
}: Props) => {
  const [firstRender, setFirstRender] = useState(false);

  useEffect(() => setFirstRender(true), []);

  const [visiblePassword, setVisiblePassword] = useState(false);
  const toggleVisible = () => setVisiblePassword(!visiblePassword);
  const toggle = () => {
    if (!isSubmit) {
      onToggle();
    }
  };

  const [value, setValue] = useState('');
  const onTextChange = (e: any) => setValue(e.target.value);
  useEffect(() => {
    setValue('');
  }, [isOpen]);

  const onSubmit = (e: any) => {
    e.preventDefault();
    onClick(value);
  };

  return (
    <Modal modalClassName="modal-password" isOpen={isOpen} toggle={toggle}>
      <div className="password-header">
        <span>{titleModal}</span>
      </div>
      <div className="password-content">
        {hasPassword === false ? (
          <div style={{ padding: '1rem', textAlign: 'center' }}>
            <p>
              You do not have inserted any password yet. Please click link below
              to create your password:
            </p>
            <a
              href="/forgot-password"
              className="text-black d-block"
              style={{ color: '#4990e2' }}
            >
              <span>Forgot Password</span>
            </a>
          </div>
        ) : (
          <div>
            <div className="text-desc">
              <p>Please enter your password to continue</p>
            </div>
            <Form onSubmit={onSubmit}>
              <FormGroup className="password-input">
                <div className='input-container-with-eye'>
                  <InputGroup>
                    <Input
                      disabled={isSubmit}
                      type={visiblePassword ? 'text' : 'password'}
                      value={value}
                      onChange={onTextChange}
                      className={errorMessage ? 'error' : ''}
                      placeholder={'Enter Password'}
                    />
                  </InputGroup>
                  <KickImage
                    className="img-eye"
                    src={visiblePassword ? eyeOpen : eyeClose}
                    onClick={toggleVisible}
                    alt="visible-password"
                  />
                </div>
                {/* <p className="invalid-password">{error === true ? errorMessage : error}</p> */}
                <p className="invalid-password">
                  {errorMessage ? errorMessage : ''}
                </p>
              </FormGroup>
              <div className="password-button">
                {
                  <Button
                    disabled={isSubmit || value === ''}
                    className={'password-content'}
                    style={{
                      backgroundColor:
                        isSubmit || value === '' ? '#4a4a4a' : '#159953',
                    }}
                  >
                    {isSubmit ? 'Loading...' : 'Submit'}
                  </Button>
                }
                <a
                  href="/forgot-password"
                  className="text-black d-block"
                  style={{ color: '#159953', textAlign: 'center' }}
                >
                  Forgot password?
                </a>
              </div>
            </Form>
          </div>
        )}
      </div>
    </Modal>
  );
};

export default ModalPasswordV3;
